import React, { useState } from 'react';
import './log_in.css'; 

export default function LogInMobile({
  phone,
  setPhone,
  password,
  setPassword,
  error,
  loading,
  onLogin,
  onNavigate
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    // تم تغيير الاتجاه هنا إلى rtl
    <div className="login-mobile-container" dir="rtl">
      <div className="login-mobile-content">
        <img 
          className='syria-logo-login-logo' 
          src="/images/Emblem_of_Syria_(2025–present).svg.png" 
          alt="Syria Logo" 
        />
        <h1 className="login-title mobile-title">الجمهورية العربية السورية</h1>
        <h4 className="login-sub mobile-sub">وزارة الصحة - منصة التنبؤ بالأوبئة</h4>
        
        <form className="login-form mobile-form" onSubmit={onLogin}>
          <h2 className="login-sub title-right">تسجيل الدخول</h2>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="input-row">
            <input
              placeholder="رقم الهاتف أو اسم المستخدم"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              required
            />
            <div className="icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2f4f7a" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
          </div>

          <div className="pass-row">
            <input
              placeholder="كلمة المرور" 
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? 'text' : 'password'}
              required
            />
            <div 
              className="icon lock" 
              aria-hidden 
              onClick={() => setShowPassword(!showPassword)} 
              style={{ cursor: 'pointer' }}
            >
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#9aa7b5" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
          </div>

          <button className="primary" type="submit" disabled={loading}>
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>

          <div className="login-links">
           <p> لا تملك حساباً؟
           <span className="login-link" onClick={() => onNavigate('register_step1')}>سجل الآن</span>
           </p>

           <p>
           <span className="login-link" onClick={() => onNavigate('login-support')}> تواجه مشكلة في تسجيل الدخول؟</span>
           </p>
          </div>
        </form>
      </div>
    </div>
  );
}